// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"main_mainContent__1Ucyf","entries":"main_entries__t8eFJ","sidebar":"main_sidebar__1R239"};